var isValidStaticProp = function isValidStaticProp(str) {
  return !!(str && !str.includes('{{'));
};
export default isValidStaticProp;